<script lang="ts">
  import { onMount } from "svelte";
  import InlinePostCard from "$lib/molecules/newsroom/cards/InlinePostCard.svelte";
  export let posts: any;
</script>

<div class="">
  {#if posts}
    {#each posts as post, i}
      <InlinePostCard {post} {i} isLast={i === posts.length - 1} />
    {/each}
  {/if}
</div>
